<template>
  <div class="rule-box">
    <!-- <v-head :title="title"></v-head> -->
    <div class="content" style="padding: 0.3rem">
      <p>会员是学会的主体和基础，大力发展并密切联系和积极服务单位会员是我们的一贯宗旨，也是实现学会科学发展的重要任务。
        为此，中国地震学会欢迎符合入会条件的地震及相关领域的企事业单位、科研院所、大专院校及个人加入。</p>
    </div>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item title="一、入会条件和程序：" name="2">
        <div class="content">
          <p>本会的会员包括个人会员和单位会员。个人会员包括：普通会员、学生会员和外籍会员。</p>
          <p>申请加入本会，必须具备下列条件</p>
          <p>（一）拥护本会的章程；</p>
          <p>（二）有加入本会的意愿；</p>
          <p>（三）普通会员应为具有中级或相当于中级以上专业技术职称的科技人员；获得地震或与地震科技相关学士学位科技人员；热心并积极支持本会工作，并具有相应专业知识的管理工作者。</p>
          <p>（四）学生会员应为热心于防震减灾事业的在读研究生。学生会员毕业后转为个人会员。</p>
          <p>（五）外籍会员应具有在地震科技领域上有较高学术造诣,对我国友好,并愿意与我会联系、交流和合作的外籍科技工作者。</p>
          <p>
            （六）单位会员应是依法登记并与本会专业有关，具有一定数量科技人员，愿意参加学会有关活动并支持学会工作，合法设立的科研、教学、生产、设计、技术应用与服务等类型的事业、企业单位以及社会团体（港澳台地区民间社会团体除外）。
          </p>
          <p> 会员入会程序</p>
          <p>（一）普通会员和学生会员下载填写中国地震学会个人会员入会申请表.doc，并将盖章纸质表格寄至：北京市海淀区民族大学南路5号 中国地震学会办公室 010-68729352，经本会办公室审核后准予缴费入会。</p>
          <p>（二）外籍会员由本人向本会提交入会申请，经本会理事会或常务理事会批准后准予入会。</p>
          <p>（三）单位会员由单位提交入会申请表，经本会理事会或常务理事会批准后准予入会。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="二、会员的权利和义务：" name="3">
        <div class="content">
          <p>普通会员享有下列权利</p>
          <p> （一）本会的选举权、被选举权和表决权；</p>
          <p>（二）参加本会活动的优先、优惠权，获得本会服务的优先权；</p>
          <p>（三）对本会工作的建议权和监督权；</p>
          <p> （四）受聘担任本会分支机构委员及委员以上职务的权利；</p>
          <p> （五）本会表彰奖励和人才举荐的资格。</p>
          <p>学生会员享有下列权利</p>
          <p>（一）对本会工作的建议权和监督权；</p>
          <p>（二）减或免交参加本会活动的注册费；</p>
          <p>（三）本会表彰奖励和人才举荐的资格。</p>
          <p>外籍会员享有下列权利</p>
          <p>普通会员除选举权、被选举权和表决权以外的各项权利和义务。</p>
          <p> 单位会员享有下列权利</p>
          <p> （一）推荐学会换届大会会员代表和理事会候选人，会员代表有选举权、被选举权和表决权；</p>
          <p>（二）优先、优惠参加本会的活动；</p>
          <p>（三）获得本会服务的优先权；</p>
          <p>（四）推荐人才和学术奖励等候选人，包括 “两院院士”、“地震科学技术奖”、“全国优秀科技工作者”候选人等；</p>
          <p>（五）推荐的本单位个人会员免收个人会员本年度会费；</p>
          <p>（六）对本会工作的批评建议权和监督权。</p>
          <p> 会员应履行的义务</p>
          <p>（一）遵守本会的章程，维护本会的合法权益；</p>
          <p>（二）执行本会的决议，完成本会交与的任务；</p>
          <p>（三）宣传本会的宗旨和作用，关心本会的建设与发展，积极参与本会的活动；</p>
          <p>（四）按规定缴纳会费；</p>
          <p>（五）入会自愿、退会自由。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="三、会员管理：" name="4">
        <div class="content">
          <p>会员的会籍由本会办公室负责管理，会员可在本网站进行查询及更新会员信息。</p>
          <p>本会的分支机构和单位会员协助本会进行会员的日常管理工作。单位会员应具有1-2名协助本会进行会员管理的联络人。</p>
          <p>会员退会应书面通知本会办公室。单位会员与外籍会员退会需经本会常务理事会批准。非本会会员，不得担任总会及分支机构的职务。</p>
          <p>对违法违纪和违反本会章程的会员，由本会理事会或常务理事会决定处罚方式。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="四、会费交纳：" name="5">
        <div class="content">
          <p>普通会员、学生会员和外籍会员：年度会费标准为100元/人；一次性交纳2000元，成为本会永久会员，终身免交年度会费。

单位会员的会费按照单位会员所包含的个人会员人数（包括普通会员和永久会员）为基准收取：

0～50人，  5000元/年；

51～100人，10000元/年；

101人以上，20000元/年。</p>
          <p>单位会员暂以自愿捐赠和协助学会开展活动的方式支持学会工作，待会费标准通过第十次会员代表大会审议后再行缴纳。</p>
          <p>2、会费交纳办法</p>
          <p> （一）普通会员和学生会员可通过网络缴费、银行转账或到本会办公室交纳会费。银行转账需注明会员姓名和单位。</p>
          <p>（二）单位会员实行一年一次交费制，通过银行转账交纳会费，交费时间不晚于当年的6月30日。</p>
          <p>（三）收到会费后，本会开具财政部监制的“全国性社会团体会费统一票据”。</p>
        </div>
      </van-collapse-item>

    </van-collapse>
  </div>
</template>

<script>
  import vHead from "../../components/Subhead";
  import { Collapse, CollapseItem } from "vant";

  export default {
    data() {
      return {
        activeNames: '1',
        title: "入会须知"
      };
    },
    components: {
      vHead,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem
    }
  };
</script>

<style lang="less" scoped>
  .content {
    font-size: 14px;
    line-height: 2;
    color: #333;
  }

  p {
    margin-bottom: 10px;

    color: #333;
  }

  b {
    font-weight: bold;
    margin-right: 10px;
  }

  ul {
    li {
      margin: 5px 0;
      font-size: 13px;
      color: #666;
    }
  }

  /deep/.van-cell {
    padding: 15px 20px;
  }
</style>